<script setup>
import {ref} from "vue";
import AppsumoWebsiteFormStep1 from "@/components/website/appsumo/AppsumoWebsiteFormStep1.vue";
import AppsumoWebsiteFormStep2 from "@/components/website/appsumo/AppsumoWebsiteFormStep2.vue";
import AppsumoWebsiteFormStep3 from "@/components/website/appsumo/AppsumoWebsiteFormStep3.vue";

defineProps({
  countries: {
    required: true,
    type: Object,
  },
  industries: {
    required: true,
    type: Object,
  },
  requiresPaymentDetails: {
    required: true,
    type: Boolean,
  },
  price: {
    required: true,
    type: String,
  },
  vat: {
    required: true,
    type: String,
  },
  cardHolderName: {
    required: true,
    type: String,
  },
  freeWebsite: {
    required: true,
    type: Boolean,
  },
});

const firstStep = 1;
const lastStep = 3;
const currentStep = ref(firstStep);

const handleNext = () => {
  if (currentStep.value < lastStep) {
    currentStep.value++
  }
}
const handleBack = () => {
  if (currentStep.value > firstStep) {
    currentStep.value--;
  }
}
</script>


<template>
  <AppsumoWebsiteFormStep1
    v-if="currentStep === 1"
    @next="handleNext"
  />

  <AppsumoWebsiteFormStep2
    v-else-if="currentStep === 2"
    :countries="countries"
    :industries="industries"
    :free-website="freeWebsite"
    @next="handleNext"
    @back="handleBack"
  />

  <AppsumoWebsiteFormStep3
    v-else-if="currentStep === 3"
    :price="price"
    :vat="vat"
    :card-holder-name="cardHolderName"
    :requires-payment-details="requiresPaymentDetails"
    @back="handleBack"
  />
</template>
